export const createFilledArray = (length: number, fillWith: any) => new Array(length).fill(fillWith);
